import { io, type Socket } from 'socket.io-client';
import { API_URL } from './api';

/**
 * The `/signaling` namespace. The dashboard is a listener here, not a
 * participant: it watches presence and session changes so a screen left
 * open stays true, and never emits call or chat events of its own.
 */
export function createSignalingSocket(token: string): Socket {
  return io(`${API_URL}/signaling`, {
    auth: { token },
    transports: ['websocket'],
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10_000,
  });
}

export interface PresenceUpdate {
  userId: string;
  online: boolean;
}

export interface SessionChanged {
  sessionId: string;
  status: string;
  change:
    | 'booked'
    | 'cancelled'
    | 'rescheduled'
    | 'ended'
    | 'tutor_changed'
    | 'cancelled_by_admin'
    | string;
  by?: string;
}

export interface ChatMessageEvent {
  sessionId: string;
  messageId: string;
  senderId: string;
  body: string;
  sentAt: string;
}
